import { render, staticRenderFns } from "./CreateContentButtons.vue?vue&type=template&id=1948a5ce&scoped=true"
import script from "./CreateContentButtons.vue?vue&type=script&lang=js"
export * from "./CreateContentButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948a5ce",
  null
  
)

export default component.exports